import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { readers, Reader } from '../data/readers';
const FIRST_DELAY = 10000;
const INTERVAL = 15000;
const VISIBLE = 4500;
export function ReaderPings() {
  const [current, setCurrent] = useState<Reader | null>(null);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let idx = Math.floor(Math.random() * readers.length);
    const show = () => {
      idx = (idx + 1) % readers.length;
      setCurrent(readers[idx]);
      hideTimer = setTimeout(() => setCurrent(null), VISIBLE);
    };
    const first = setTimeout(show, FIRST_DELAY);
    const cycle = setInterval(show, INTERVAL);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(cycle);
    };
  }, []);
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 right-4 sm:right-auto sm:bottom-6 sm:left-6 z-40 flex" data-id="element-94" data-mp="3okyeu4g9hnr8">
      <AnimatePresence data-id="element-95" data-mp="1iszzen95s5du">
        {current && <motion.div key={current.name + current.location} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 8,
        transition: {
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-center gap-3 rounded-xl border border-brand-gold/40 bg-brand-anthracite/95 backdrop-blur-sm px-4 py-3 shadow-[0_8px_30px_rgba(0,0,0,0.6)] w-full sm:w-auto sm:max-w-sm" data-id="element-96" data-mp="1ivcfeuvcw5o9">
            <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-brand-dark border border-brand-gold/30 shrink-0" data-id="element-97" data-mp="2khtt3qar14jp">
              <BookOpen className="w-4 h-4 text-brand-gold" data-id="element-98" data-mp="2pb51hvv7ltdq" />
            </span>
            <div className="min-w-0" data-id="element-99" data-mp="2z4j0eeb8sm0n">
              <p className="text-sm font-medium text-white leading-tight truncate" data-id="element-100" data-mp="2u6h6eyca32ae">
                {current.name} accedió al archivo
              </p>
              <p className="text-xs text-brand-gold/90 leading-tight truncate mt-0.5" data-id="element-101" data-mp="2p5jq6ratwibj">
                {current.location}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}